import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface BbSegmentedOption {
  value: string;
  label: string;
}

/** Segmented control (pill group). Parent owns selection via [value]/(valueChange). */
@Component({
  selector: 'bb-segmented',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="inline-flex gap-1 rounded-md bg-muted p-1">
      @for (opt of options(); track opt.value) {
        <button
          type="button"
          (click)="valueChange.emit(opt.value)"
          class="rounded-md px-4 py-2 font-heading text-sm font-bold transition-colors"
          [class]="opt.value === value()
            ? 'bg-card text-foreground shadow-sm'
            : 'bg-transparent text-muted-foreground hover:text-foreground'">
          {{ opt.label }}
        </button>
      }
    </div>
  `,
})
export class BbSegmented {
  readonly options = input<BbSegmentedOption[]>([]);
  readonly value = input<string>('');
  readonly valueChange = output<string>();
}
